export default __webpack_public_path__ + "63bedbf2b0c197a8d79e85f98b60ce58.png";